export default __webpack_public_path__ + "static/media/hht2_ep6_speaking_01.a6bc2b81.png";